// A glossy finish for a brand-orange surface: a soft light cap on the top half, and a diagonal shine that sweeps from left to
// right now and then (the same `.tile-shine` animation the glossy Buy Credit tile and the dashboard shortcuts use).
//
// The parent needs `relative overflow-hidden` (and its own rounding). Content that must stay crisp (icon, label) goes in
// `relative` elements AFTER this one so it paints on top of the gloss.
export default function GlossShine() {
    return (
        <>
            <span aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-white/40 to-white/0" />
            <span aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
                <span className="tile-shine absolute inset-y-0 -left-1/2 w-1/3 bg-gradient-to-r from-white/0 via-white/60 to-white/0" />
            </span>
        </>
    );
}
